import { render } from "./ReportAwol.vue?vue&type=template&id=23f248a4&scoped=true"
import script from "./ReportAwol.vue?vue&type=script&lang=js"
export * from "./ReportAwol.vue?vue&type=script&lang=js"

import "./ReportAwol.vue?vue&type=style&index=0&id=23f248a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f248a4"]])

export default __exports__